import german from '../i18n/datatables/german';

class User {
    init() {
        this.$tableWrapper = $("#user-table-wrapper");
        this.$table = this.$tableWrapper.find("table");

        if (this.$table.length === 0) {
            return;
        }

        this.initDataTable();
    }

    initDataTable() {
        this.$table.DataTable({
            language: german,
            sScrollX: "100%",
            bScrollCollapse: true
        });

        this.$table.on("draw.dt", () => {
            this.$tableWrapper.fadeIn();
            $('[data-toggle="tooltip"]').tooltip();
        });
    }
}

export default User;